import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const HomeCheckmark = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M11.5 14.5L14 12" />
      <path d="M10 13L11.5 14.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 16.5V10.9597C3 9.5927 3.62139 8.29979 4.68885 7.44582L8.8765 4.09568C10.7026 2.63477 13.2974 2.63477 15.1235 4.09568L19.3111 7.44581C20.3786 8.29978 21 9.59269 21 10.9597V16.5C21 18.9853 18.9853 21 16.5 21H7.5C5.01472 21 3 18.9853 3 16.5Z"
      />
    </svg>
  );
};
